<template>
    <div>
        <nav-breadcrumb :menu="[{label: ' 待审核预约'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import moment from 'moment'
    export default {
        name: "BranchAppointmentList",
        data(){
            return{
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '预约编号',
                        field: 'a__appointmentNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'ba__customerName'
                    },
                    {
                        label: '身份证号码',
                        field: 'ba__customerIC'
                    },
                    {
                        label: '分公司',
                        field: 'bo__branchName'
                    },
                    {
                        label: '面签时间',
                        field: 'a__signingTime',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }

                    },
                    {
                        label: '面签室',
                        field: 'r__roomName'
                    },
                    {
                        label: '状态',
                        field: 'a__appointmentStatus',
                        formatter: function (r,c,v) {
                            return   Status2CN('a__'+v)
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '审核',
                                class: 'el-icon-success',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'approve',
                                            query: {
                                                appointmentId: row.a__appointmentId
                                            }
                                        }
                                    )
                                }
                            },
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        a__appointmentNo:'',
                        ba__customerName:'',
                        bo__branchId:'',
                        a__signingTime:[],
                    },
                    columns: [

                        {
                            label: '预约编号',
                            component: 'el-input',
                            field: 'a__appointmentNo',
                            span:8
                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'ba__customerName',
                            span:8
                        },
                        {
                            label: '分公司',
                            component: 'el-select',
                            field: 'bo__branchId',
                            options: [],
                            span: 8
                        },
                        {
                            label: '面签日期',
                            component: 'date-range-picker',
                            field: 'a__signingTime',
                            op: ['gteq', 'lteq'],
                            span: 16
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
            this.getDataBranchOfficeSelect()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.search.a.appointmentStatus' : 'Pending Approval',
                    'xlist.search.a.appointmentStatus.op' : 'in',
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getBranchAppointmentList(
                    Object.assign({ }, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
            getDataBranchOfficeSelect: function () {
                xhr.getDataBranchOfficeSelect(
                    Object.assign({}, {}, {}),
                    res=> {
                        try {
                            this.filters.columns[2].options = res.data.data.map(item=>{
                                return {
                                    label: item.bo__branchName,
                                    value:item.bo__branchId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            removeItem: function (index, row) {
                removeItem(
                    xhr.deleteBranchOffice,
                    {
                        'bo.branchId' : row.bo__branchId
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }
                )
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchAppointmentList.vue